// extracted by css-extract-rspack-plugin
export default {"languageDot":"LanguageDot-module__languageDot__WZEoH","languageDotCompact":"LanguageDot-module__languageDotCompact__BuFrL"};